import { render, staticRenderFns } from "./richColorful.vue?vue&type=template&id=6388ec70&scoped=true"
import script from "./richColorful.vue?vue&type=script&lang=js"
export * from "./richColorful.vue?vue&type=script&lang=js"
import style0 from "./richColorful.vue?vue&type=style&index=0&id=6388ec70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6388ec70",
  null
  
)

export default component.exports